import type { FC, ReactNode } from 'react';
import { Radar } from 'lucide-react';

interface GuidanceHeroProps {
  title: string;
  children: ReactNode;
}

/** Centred icon, heading and one paragraph — the top of the intro and scanning panels. */
export const GuidanceHero: FC<GuidanceHeroProps> = ({ title, children }) => (
  <div className="flex flex-col items-center px-6 pt-8 pb-6 text-center">
    <div className="flex size-12 items-center justify-center rounded-full bg-violet-100 text-violet-600">
      <Radar className="size-6" aria-hidden />
    </div>
    <h3 className="mt-4 text-base font-semibold text-gray-900">{title}</h3>
    <p className="mt-1.5 text-[13px] leading-relaxed text-gray-500">{children}</p>
  </div>
);
